module.exports = __webpack_public_path__ + "static/media/ic_navigation_double_arrow_left.7846d3db.svg";